__turbopack_context__.v({
  "leftAlign": "StatusDisplay-module__cMSuoG__leftAlign",
  "resultDescription": "StatusDisplay-module__cMSuoG__resultDescription",
  "resultHeader": "StatusDisplay-module__cMSuoG__resultHeader",
  "resultMessageWrapper": "StatusDisplay-module__cMSuoG__resultMessageWrapper",
  "resultSubhead": "StatusDisplay-module__cMSuoG__resultSubhead",
  "returnActionCta": "StatusDisplay-module__cMSuoG__returnActionCta",
  "statusDisplayBodyWrapper": "StatusDisplay-module__cMSuoG__statusDisplayBodyWrapper",
  "statusDisplayWrapper": "StatusDisplay-module__cMSuoG__statusDisplayWrapper",
});
